import { gql } from 'graphql-request';

export const MATERIAL_FIELDS = gql`
  fragment MaterialFields on MaterialDto {
    materialId
    name
    supplier
    time
    amount
    amountType
    amountSystem
    costPerUnit
    pricePerUnit
    taskId
    chargeToClient
  }
`;

export const getMaterials = gql`
  query getMaterials($taskId: String!) {
    getMaterials(taskId: $taskId) {
      ...MaterialFields
    }
  }
  ${MATERIAL_FIELDS}
`;

export const createMaterial = gql`
  mutation createMaterial($material: MaterialCreateInput!) {
    createMaterial(material: $material) {
      ...MaterialFields
    }
  }
  ${MATERIAL_FIELDS}
`;

export const updateMaterial = gql`
  mutation updateMaterial($material: MaterialUpdateInput!) {
    updateMaterial(material: $material) {
      ...MaterialFields
    }
  }
  ${MATERIAL_FIELDS}
`;

export const deleteMaterial = gql`
  mutation deleteMaterial($id: String!) {
    deleteMaterial(id: $id) {
      affected
    }
  }
`;

const MaterialGraphQL = {
  queries: {
    getMaterials,
  },
  mutations: {
    createMaterial,
    updateMaterial,
    deleteMaterial,
  },
};

export default MaterialGraphQL;
